"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _EventInfo = require("./EventInfo");

var Summary = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var summary = _ref.summary;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-primary text-white items-center justify-left text-2xl py-4 px-6 min-h-14 max-h-18 w-full truncate"
  }, summary.replace(/\\n/g, ''));
});

var ICS = /*#__PURE__*/_react["default"].memo(function (data) {
  var summary = data.summary,
      onClose = data.onClose,
      others = (0, _objectWithoutProperties2["default"])(data, ["summary", "onClose"]);
  var handleClose = (0, _react.useCallback)(function () {
    if (onClose) {
      onClose();
    }
  }, [onClose]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleClose,
    className: "flex flex-col justify-center items-center h-full w-full p-10 overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "shadow-lg flex flex-col bg-card space-between items-left w-full max-w-2xl overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement(Summary, {
    summary: summary
  }), /*#__PURE__*/_react["default"].createElement(_EventInfo.EventDetailInfo, others)));
});

var _default = ICS;
exports["default"] = _default;
//# sourceMappingURL=ICS.js.map